import { createNode } from '@glueapp/graph-types';
import { DataType } from '@glueapp/graph-types';
import { DataValue } from '@glueapp/graph-types';

const VariableValuePortType: DataType = {
    kind: 'generic',
    identifier: 'T',
};

export const GetVariable = createNode({
    id: 'Get Variable',
    name: 'Get Variable',
    description: 'A block for getting the value of a variable',
    aiDescription: [
        'Reads the current value of a graph variable.',
        'Setup:',
        '1. Add the node: glue add "Get Variable"',
        '2. Select which variable to read using state:',
        '   glue set-state <id> selectedVariable "myVariableName"',
        '3. Run glue shape <id> to see the resolved output port type.',
        '',
        'computeShape behavior:',
        '- When selectedVariable is set and the variable has a resolved type, the "Variable" output',
        "  port is typed to match the variable's type.",
        '- Without a selected variable or unresolved type, the output port remains generic.',
        '',
        'No input ports. Single output port "Variable" emitting the variable\'s current value.',
        '',
        'Example:',
        '  glue add "Get Variable"  # returns <id>',
        '  glue set-state <id> selectedVariable "counter"',
        '  glue shape <id>  # shows "Variable" output typed to the variable\'s type',
        '  glue connect <id>:Variable <other-node>:Input',
    ].join('\n'),
    category: 'Variables',
    color: '#7d898f',
    integration: undefined,
    inPorts: {},
    computeShape: input => {
        if (input.selectedVariable && input.selectedVariable.resolvedType) {
            return {
                inPorts: [],
                outPorts: [{ name: 'Variable', type: { ...VariableValuePortType, resolvedType: input.selectedVariable.resolvedType } }],
            };
        }
        return {
            inPorts: input.nodeInPorts,
            outPorts: input.nodeOutPorts,
        };
    },
    outPorts: {
        Variable: VariableValuePortType,
    },
    execute: function (input) {
        const variableValue = input.variableValue as DataValue;
        return { output: { Variable: variableValue } };
    },
});
